import React from "react";
import CreateNewArticleContainer from "./view/create-new-article-container";
import VideoListContainer from "./view/video-list-container";
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  root: {
    flexGrow: 1,
  },
});


class ArticleHomePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      refreshKey: 0,
    };
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
  }

  handleUploadSuccess() {
    // Increment refreshKey to trigger VideoListContainer to refetch
    this.setState(function (prevState) {
      return { refreshKey: prevState.refreshKey + 1 };
    });
  }

  render() {
    return (
      <>
        <CreateNewArticleContainer onUploadSuccess={this.handleUploadSuccess} />
        <VideoListContainer refreshKey={this.state.refreshKey} />
      </>
    );
  }
}

export default withStyles(styles)(ArticleHomePage);
